




















































































































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import { resolveCatalogEntityId } from '../utils/openCatalogEntity';
import ProductCombobox from "@/components/Controls/ProductCombobox.vue";
import ProductContainerCombobox from "@/components/Controls/ProductContainerCombobox.vue";

const isValidThreeDecimalInput = (value: any) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }

  const stringValue = String(value).trim();
  return /^-?\d+([.,]\d{1,3})?$/.test(stringValue);
};

@Component({
  components: {ProductContainerCombobox, ProductCombobox},
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'stickers', 'primeCostForm'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      product_id: { },
      sticker_id: { },
      name: { required, minLength: minLength(3) },
      position: { },
      weight: { isValidThreeDecimalInput },
      volume: { isValidThreeDecimalInput },
      solders: { },
      price: { },
      is_sample: { },
      barcode: { },
      barcode_format: { },
      sku: { },
      sku_mixcart: { },
      sku_1c: { },
      sku_academy_coffie: { },
      sku_japan_house: { },
      price_per_kg: { },
      discount_percent: { },
      base_product_container_id: { },
    }

    return {
      form: rules
    }
  }
})
export default class ProductContainerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any
  primeCostForm!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public stickers!: any[];
  public filters: any = {
    sticker_id: null
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log('this.isNew)', this.isNew);
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      const entityId = resolveCatalogEntityId(this, this.documentPreview);
      if (entityId != null) {
        this.$store.dispatch(`${STORE_KEY}/init`, { id: entityId });
      }
    }
  }

  get getWeightFieldError(): string | null {
    const w = this.$v?.form?.weight;
    if (!w?.$dirty) {
      return null;
    }

    if (!w.isValidThreeDecimalInput) {
      return 'Допустимо не более 3 знаков после запятой';
    }

    return getFieldError.call(this as Vue, 'weight');
  }

  get getVolumeFieldError(): string | null {
    const v = this.$v?.form?.volume;
    if (!v?.$dirty) {
      return null;
    }

    if (!v.isValidThreeDecimalInput) {
      return 'Допустимо не более 3 знаков после запятой';
    }

    return getFieldError.call(this as Vue, 'volume');
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  changePrimeCostValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changePrimeCostValue`, {
      field,
      newValue: value
    });
  }

  handleWeightInput(value: any) {
    const normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value;

    if (normalizedValue !== value) {
      console.debug('[ProductContainerForm] normalized tare weight input separator', {
        from: value,
        to: normalizedValue
      });
    }

    if (!isValidThreeDecimalInput(normalizedValue)) {
      console.debug('[ProductContainerForm] rejected tare weight precision', {
        value: normalizedValue
      });
    }

    this.changeValue('weight', normalizedValue);
  }

  handleVolumeInput(value: any) {
    const normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value;

    if (normalizedValue !== value) {
      console.debug('[ProductContainerForm] normalized volume input separator', {
        from: value,
        to: normalizedValue
      });
    }

    if (!isValidThreeDecimalInput(normalizedValue)) {
      console.debug('[ProductContainerForm] rejected volume precision', {
        value: normalizedValue
      });
    }

    this.changeValue('volume', normalizedValue);
  }

  addSticker(sticker: any) {
    const stickers: any[] = this.stickers.map((sticker: any) => sticker.sticker_id);
    if (sticker && !stickers.includes(sticker.id)) {
      this.$store.dispatch(`${STORE_KEY}/addSticker`, {
        id: sticker.id,
        label: sticker.label
      });
      this.filters.sticker_id = null

    }
  }

  removeSticker(index: any) {
    if (index > -1) {
      this.$store.dispatch(`${STORE_KEY}/removeSticker`, index);
    }
  }

  setSubstandard(value: any) {
    Object.keys(value).map((key: any) => {
      if (!['id', 'label', 'name'].includes(key)) {
        this.changeValue(key, value[key])
      } else if (key == 'name') {
        this.changeValue(key, value[key] + ' (не кондиция)')
      }
    })
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, resolveCatalogEntityId(this, this.documentPreview))
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

